import type { ClientMail } from '@game/shared-types';
import type { RowSelectionState } from '@game/ui';

type MailBoxState = 'inbox' | 'read-inbox-mail' | 'read-outbox-mail' | 'reply-mail' | 'new-mail';

export interface MailState {
  inbox: ClientMail[];
  outbox: ClientMail[];
  selectedMailRowKeys: RowSelectionState;
  activeMail: ClientMail | null;
  mailState: MailBoxState;
}

export const defaultMail: ClientMail = {
  id: '',
  subject: '',
  body: '',
  to: {
    name: '',
    roles: [],
    tags: [],
  },
  from: {
    name: '',
    roles: [],
    tags: [],
  },
  date: new Date(),
  read: true,
};

export const mailDefault: MailState = {
  selectedMailRowKeys: {},
  inbox: [],
  outbox: [],
  activeMail: null,
  mailState: 'inbox',
};
